import {
  BasicButton,
  DangerButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
} from "@certn/cascadia";
import { Text } from "@certn/cascadia";
import { useTranslation } from "react-i18next";

interface CancelModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function CancelModal({ isOpen, onClose, onConfirm }: CancelModalProps) {
  const { t } = useTranslation();

  return (
    <Modal testID="cancel-modal" isOpen={isOpen} onOpenChange={onClose}>
      <Dialog>
        <DialogHeader onClose={onClose}>
          {t("Cancel template creation")}
        </DialogHeader>
        <DialogContent>
          <Text>
            {t(
              "Are you sure you want to cancel? All unsaved changes will be lost."
            )}
          </Text>
        </DialogContent>
        <DialogFooter>
          <BasicButton onPress={onClose} testID="keep-editing">
            {t("Keep editing")}
          </BasicButton>
          <DangerButton onPress={onConfirm} testID="confirm-cancel">
            {t("Cancel creation")}
          </DangerButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
